import { render, staticRenderFns } from "./discount.vue?vue&type=template&id=1f6911eb&scoped=true&"
import script from "./discount.vue?vue&type=script&lang=ts&"
export * from "./discount.vue?vue&type=script&lang=ts&"
import style0 from "./discount.vue?vue&type=style&index=0&id=1f6911eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6911eb",
  null
  
)

export default component.exports